import React, { lazy, Suspense } from 'react';

interface BreadcrumbItem {
    label: string;
    href: string;
}

type Props = {
    breadcrumb?: BreadcrumbItem[];
};

const LazyLink = lazy(() => import('react-router-dom').then(module => ({ default: module.Link })));

const Breadcrumb: React.FC<Props> = ({ breadcrumb }) => {
    return (
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-center">
                {breadcrumb &&
                    breadcrumb.map((item, index) => (
                        <li key={index} className={`breadcrumb-item ${index === breadcrumb.length - 1 ? 'active' : ''}`}>
                            {index === breadcrumb.length - 1 ? (
                                <span>{item.label}</span>
                            ) : (
                                <span>
                                    <Suspense fallback={<span>Loading...</span>}>
                                        <LazyLink to={item.href}>{item.label}</LazyLink>
                                    </Suspense>
                                </span>
                            )}
                        </li>
                    ))}
            </ol>
        </nav>
    );
};

export default Breadcrumb;
